<template>
  <div class="edu">
    <breadcrumb></breadcrumb>
    <div class="edu-content">
      <div class="state-list">
        <span> </span>
        <el-button
          v-if="power(userInfo.menuInfoList, 'topicResearch-addActive')"
          type="primary"
          class="el-icon-plus"
          size="small"
          @click="toPathAdd"
          >新增德育活动</el-button
        >
      </div>
      <div class="search-list">
        <span>
          <el-checkbox
            label="1"
            v-model="form.isCreator"
            @change="query"
            :true-label="1"
            :false-label="0"
            >我发起的</el-checkbox
          >
        </span>

        <el-input
          class="input-length"
          size="small"
          placeholder="搜索活动名称"
          v-model="form.keyword"
          style="width: 205px"
          clearable
        >
          <el-button
            slot="append"
            type="primary"
            class="search-btn"
            size="small"
            @click="query"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div class="data-list" v-loading="pageLoading">
        <card-list
          moduleType="moralResearch"
          :dataList="dataList"
          @delSuccess="query"
        ></card-list>
        <!-- 分页 -->
        <pagination
          :pageObj="pageObj"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import CardList from "@/components/common/CardList.vue";
import Pagination from "@/components/Pagination.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState, mapGetters } from "vuex";
import { power } from "@/utils/index.js";
import DicCodeSelector from "@/components/common/DicCodeSelector.vue";
export default {
  computed: {
    ...mapState(["userInfo", "resOptions"]),
    ...mapGetters(["schoolCodes"]),
  },
  components: {
    CardList,
    Breadcrumb,
    Pagination,
    DicCodeSelector,
  },
  data() {
    return {
      form: {
        actType: "moral",
        activeStatus: 1,
        classify4: "",
        schoolCode: "",
        // classify2: "",
        isMe: "", // 空 全部
        keyword: "",
        operatorId: "",
        pageNum: "",
        pageSize: "",
        isCreator: 0,
      },
      pageObj: {
        current: 1,
        total: 0,
        size: 8,
        sizeList: [8, 16, 24, 32],
      },
      pageLoading: true,
      dataList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    power,
    init() {
      this.selectData();
    },
    async selectData() {
      try {
        this.pageLoading = true;
        this.form.operatorId = this.userInfo.userId;
        this.form.schoolCode = this.userInfo.schoolCode;
        this.form.pageNum = this.pageObj.current;
        this.form.pageSize = this.pageObj.size;
        let { current, total, size, records } = await postJson(
          "/moral/getMoralActivityInfoList",
          this.form
        );
        this.pageObj.total = total;
        this.dataList = records;
        this.pageLoading = false;
      } catch (err) {
        console.log("err", err);
      }
    },

    toPathAdd() {
      sessionStorage.removeItem("actCode");
      this.$router.push("editMoral");
    },
    query() {
      this.pageObj.current = 1;
      this.selectData();
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.current = 1;
      this.pageObj.size = pageSize;
      this.selectData();
    },
    handleCurrentChange(curPage) {
      this.pageObj.current = curPage;
      this.selectData();
    },
  },
};
</script>


